import { useHasPauseSubscriptionGate } from '../../hooks/useHasGate';
import { useSubscription } from '../../hooks/useSubscription';
import { SubscriptionStatus } from '../../types/subscriptions';
import { ActionButton } from '../components/ActionButton';
import { jsx as _jsx } from "react/jsx-runtime";
export function PauseActionButton({
  action,
  actionType
}) {
  var _useSubscription;
  const {
    status
  } = (_useSubscription = useSubscription()) !== null && _useSubscription !== void 0 ? _useSubscription : {
    status: ''
  };
  const hasPauseSubscriptionGate = useHasPauseSubscriptionGate();
  if (!hasPauseSubscriptionGate) {
    return null;
  }
  return /*#__PURE__*/_jsx(ActionButton, {
    action: action,
    actionType: actionType,
    "data-test-id": status === SubscriptionStatus.Paused ? 'resume-subscription-button' : 'pause-subscription-button',
    label: status === SubscriptionStatus.Paused ? 'subscriptions.Actions.pause.label.resume' : 'subscriptions.Actions.pause.label.pause'
  });
}